import * as React from 'react';
import { OfferIrrevocableDate } from '@app/DashboardComponents/OfferViewComponents';
import OfferAgent from './OfferAgent';
import OfferInformation from './OfferInformation';

function AgentOfferEdit(props: any) {
  const {
    offer,
    offerDetails,
    listing,
    user,
    onDateChange,
    onTimeChange,
    selectUser,
    handleCoopForm,
    openFileUpload,
    attachmentForm801,
    deleteAttachmentForm,
    hasListingAccess,
    getDateErrorMessage,
  } = props;

  // Selecting the current user
  React.useEffect(() => {
    async function fetchUser() {
      await selectUser(user);
    }
    fetchUser();
  }, [offerDetails, selectUser]);

  const shouldHaveOfferDocInput =
    hasListingAccess || offerDetails.registration.shouldSubmitOfferDoc;
  const needsOfferDoc =
    !hasListingAccess && offerDetails.registration.shouldSubmitOfferDoc;

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <OfferInformation
            key={offerDetails}
            offerCount={offerDetails.offerCount}
            offerSettings={offerDetails}
            offerSubmissions={offerDetails.submission}
          />
        </div>
        <div className="col-md-6">
          <h3>Register Your Offer</h3>
          <hr />

          <div className="row p-r-xl">
            <div className="col-sm-6 col-md-12 col-lg-6">
              <OfferAgent
                user={user}
                phoneNumber={offer.coop.phone}
                onPhoneNumberChange={handleCoopForm}
              />
              <div
                style={{ display: shouldHaveOfferDocInput ? 'block' : 'none' }}
              >
                <button
                  className="btn btn-primary"
                  onClick={openFileUpload}
                  data-cy="attach-offer-doc-button"
                >
                  ATTACH OFFER DOC
                </button>
                {attachmentForm801?.url ? (
                  <div>
                    <h4>Attachments</h4>
                    <a
                      href={attachmentForm801.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {attachmentForm801.filename}
                    </a>
                    <i
                      className="pe-7s-trash fat pull-right"
                      onClick={deleteAttachmentForm}
                    ></i>
                  </div>
                ) : (
                  <>
                    <h4>No form attached.</h4>
                    {needsOfferDoc && (
                      <label className="error">Offer Doc is required.</label>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="col-sm-6 col-md-12 col-lg-6">
              <OfferIrrevocableDate
                key={offer.irrevocable}
                irrevocableDate={offer.irrevocable}
                onDateChange={onDateChange}
                onTimeChange={onTimeChange}
                listing={listing}
                errorMessage={getDateErrorMessage()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AgentOfferEdit;
